import { ReactNode } from "react";

import { Button, Drawer, Group } from "@mantine/core";

type VitalsDrawerHeaderProps = {
  title?: string;
  saveLabel?: string;
  isSaving?: boolean;
  showSave?: boolean;
  closeButton?: ReactNode;
  saveButtonProps?: {
    "data-testid"?: string;
    disabled?: boolean;
  };
  closeButtonProps?: {
    "data-testid"?: string;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
  };
};

/**
 * Shared vitals drawer chrome: gray header bar and title.
 * Keeps encounter-template drawers visually consistent with prenatal vitals.
 */
export function VitalsDrawerHeader({
  title = "Vitals",
  saveLabel = "Save",
  isSaving = false,
  showSave = true,
  closeButton,
  saveButtonProps,
  closeButtonProps,
}: VitalsDrawerHeaderProps) {
  return (
    <Drawer.Header mb="lg" px="md" bg="gray.0">
      <Group w="100%" justify="space-between">
        <Group gap="xs">
          {closeButton ?? (
            <Drawer.CloseButton size={closeButtonProps?.size ?? "xl"} {...closeButtonProps} />
          )}
          <Drawer.Title c="dark.9">{title}</Drawer.Title>
        </Group>
        {showSave && (
          <Button type="submit" loading={isSaving} {...saveButtonProps}>
            {saveLabel}
          </Button>
        )}
      </Group>
    </Drawer.Header>
  );
}
